import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createSession } from "../lib/api";

// AuthCallback: reads session_id from URL fragment, calls backend to establish cookie session, redirects.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await createSession(sessionId);
        // strip fragment so we don't re-process
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/admin", { replace: true });
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/admin", { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-zinc-500 font-mono">
      Establishing session…
    </div>
  );
}
